import { Box, Skeleton } from '@mui/material'


export const ProductSkeleton = () => {
    return (
        <Box width={225} height={260} sx={{
            position: "relative", borderRadius: 3, boxShadow: 2
        }}>
            <Box>
                <Skeleton variant="rounded" animation="wave"
                    width="100%" height="100px" sx={{
                        // boxShadow: 2,
                        borderRadius: "6px",
                    }} />
                <Skeleton variant="rounded" animation="wave"
                    width="120px" height="15px" sx={{
                        boxShadow: 2,
                        borderRadius: "2px",
                        position: "absolute",
                        top: "95px",
                        left: "50%",
                        transform: "translateX(-50%)",
                    }} />
            </Box>

            <Box sx={{
                width: "100%",
                mt: 2,
                px: 2,
                py: 2,
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                flexDirection: "column",
            }}>
                <Skeleton variant="rounded" animation="wave"
                    width="70px" height="10px"
                    sx={{
                        textAlign: "center",
                        boxShadow: 2,
                        borderRadius: "5px",
                        position: "relative",
                        bottom: "9px",
                        left: "50%",
                        transform: "translateX(-50%)",
                    }} />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton variant="rounded" animation="wave"
                    width="100%" height={30} sx={{ mt: 2, mb: 1 }} />
            </Box>
        </Box>
    )
}
